/* Myk rulling med Lenis, koblet til GSAP sin ticker og ScrollTrigger.
   Slås av når brukeren har bedt om redusert bevegelse. */

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import { $, $$, mindreBevegelse } from './verktoy.js';

let lenis = null;

export function startScroll() {
  if (mindreBevegelse.matches) return null;

  lenis = new Lenis({ lerp: .09, wheelMultiplier: 1 });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(t => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
  return lenis;
}

export const stoppRulling = () => lenis?.stop();
export const startRulling = () => lenis?.start();

/* Ankerlenker: rull dit, og lukk menyen først hvis den er åpen. */
export function koblAnkerlenker(lukkMeny) {
  for (const a of $$('a[href*="#"]')) {
    const href = a.getAttribute('href');
    const id = href.slice(href.indexOf('#'));
    if (id.length < 2) continue;
    // Lenker til en annen side skal navigere som vanlig.
    if (href.indexOf('#') > 0 && !href.startsWith(location.pathname)) continue;

    a.addEventListener('click', e => {
      const mal = $(id);
      if (!mal) return;
      e.preventDefault();
      const dit = () => lenis
        ? lenis.scrollTo(mal, { duration: 1.6 })
        : mal.scrollIntoView({ behavior: mindreBevegelse.matches ? 'auto' : 'smooth' });

      if (document.body.classList.contains('meny-apen')) {
        lukkMeny();
        setTimeout(dit, 350);
      } else {
        dit();
      }
      // Flytt tastaturfokus dit vi rullet, ellers fortsetter tabbingen på feil sted.
      mal.setAttribute('tabindex', '-1');
      mal.focus({ preventScroll: true });
    });
  }
}
